import useEmblaCarousel from 'embla-carousel-react';
import React from 'react';
import SvgStar from '../../components/svg/star';
import { appReviews } from '../../routes/pro_page/pro_page_data';
import styles from './reviews_carousel.less';

export const ReviewsCarousel = () => {
  const [emblaRef] = useEmblaCarousel({ loop: false, dragFree: true, align: 'start' });

  return (
    <div className={styles.embla}>
      <div className={styles.embla__viewport} ref={emblaRef}>
        <div className={styles.embla__container}>
          {appReviews.map((r, i) => (
            <div className={styles.embla__slide} key={r.userName}>
              <div key={i} className={styles.reviewCard}>
                <div className={'flex mb-2'}>
                  {Array.from({ length: r.rating }).map((_) => (
                    <SvgStar />
                  ))}
                </div>
                <p>{r.content}</p>
                <span>{r.userName}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
